// extracted by mini-css-extract-plugin
export default {"link":"_NpZMS","root":"QOvwfu","label":"EIKVqt"};